import type { LandingPageContent } from './types'

export const PHOTOVOLTAIK_WALLBOX_ELEKTROAUTO: LandingPageContent = {
  slug: 'photovoltaik-wallbox-elektroauto',
  lang: 'de',
  topicId: 'photovoltaik-wallbox-elektroauto',
  title: 'Wallbox & Elektroauto: Mit PV-Überschuss laden statt Sprit tanken',
  metaDescription:
    'Wallbox einfach bei der PV-Anfrage mit angeben, Elektroauto mit eigenem Solarstrom laden - ' +
    'kostenloser Angebotsvergleich, ganz ohne Anruf-Flut.',
  keywords: [
    'wallbox photovoltaik',
    'elektroauto mit pv laden',
    'pv überschuss laden',
    'auto umsonst fahren photovoltaik',
    'kraftstoff sparen elektroauto',
    'wallbox anfrage vergleichen',
  ],
  eyebrow: 'Wallbox + Elektroauto',
  h1: 'Wallbox & Elektroauto: Mit PV-Überschuss laden statt Sprit tanken',
  intro:
    'Ein Elektroauto mit eigenem Solarstrom zu laden, statt teuren Netzstrom oder Kraftstoff zu ' +
    'kaufen, ist einer der stärksten wirtschaftlichen Gründe für eine Photovoltaikanlage. Bei Roofora ' +
    'geben Sie eine Wallbox einfach bei Ihrer PV-Anfrage mit an - kostenlos, ohne separaten ' +
    'Auftragstyp, und vergleichen Angebote von geprüften Fachbetrieben ohne Anruf-Flut.',
  sections: [
    { type: 'heading', text: 'Wie PV-Überschussladen funktioniert' },
    {
      type: 'paragraph',
      text:
        'Beim Überschussladen lädt die Wallbox bevorzugt dann, wenn die PV-Anlage mehr Strom liefert, ' +
        'als der Haushalt gerade verbraucht - statt den Überschuss für wenige Cent ins Netz ' +
        'einzuspeisen. Technisch braucht es dafür mindestens rund 1,4 kW freie PV-Leistung beim ' +
        'einphasigen Laden bzw. rund 4,2 kW beim dreiphasigen Laden (Standard bei den meisten ' +
        'modernen Elektroautos), meist geregelt über eine "smarte" Wallbox mit automatischer ' +
        'Umschaltung.',
    },
    { type: 'heading', text: 'Kraftstoffkosten im Vergleich' },
    {
      type: 'list',
      items: [
        'Photovoltaik-Strom: rund 1,44-2 € pro 100 km (bei ca. 18-22 kWh/100 km und 8-12 ct/kWh Stromgestehungskosten)',
        'Netzstrom: rund 4,50-6 € pro 100 km (bei aktuellem Haushaltsstrompreis)',
        'Benzin: rund 16,80 € pro 100 km (bei ca. 8 l/100 km und rund 2,10 €/Liter)',
      ],
    },
    {
      type: 'paragraph',
      text:
        'Diese Werte sind externe Marktrichtwerte (Stand: August 2026), keine Roofora-eigene ' +
        'Berechnung - Kraftstoff- und Strompreise schwanken, die tatsächliche Ersparnis hängt von ' +
        'Ihrem individuellen Verbrauch und Vertrag ab.',
    },
    { type: 'heading', text: 'Wallbox einfach mitbeantragen' },
    {
      type: 'paragraph',
      text:
        'Eine Wallbox ist bei Roofora kein eigener Auftragstyp, sondern eine Option innerhalb Ihrer ' +
        'PV-Anfrage: Sie geben im Wizard einfach an, dass Sie eine Wallbox (E-Auto-Ladestation) ' +
        'wünschen, Handwerksbetriebe kalkulieren das direkt mit ein. Genauso können Sie bei der ' +
        'Anlagengröße angeben, dass Sie ein Elektroauto laden möchten - das fließt in die empfohlene ' +
        'Anlagen- und Speichergröße ein.',
    },
    { type: 'heading', text: 'Was, wenn ich schon eine PV-Anlage habe?' },
    {
      type: 'paragraph',
      text:
        'Dann reicht eine reine Elektroinstallations-Anfrage für die Wallbox-Nachrüstung, ohne dass ' +
        'Sie die komplette Anlage neu ausschreiben müssen.',
    },
  ],
  faq: [
    {
      q: 'Kostet die Wallbox-Option bei der Anfrage extra?',
      a: 'Nein - wie jede Anfrage bei Roofora ist auch die Wallbox-Angabe kostenlos, Sie erhalten unverbindliche Angebote von mehreren Betrieben.',
    },
    {
      q: 'Brauche ich einen Batteriespeicher, um mein Auto mit Solarstrom zu laden?',
      a: 'Nicht zwingend - Überschussladen funktioniert auch ohne Speicher, solange die Sonne scheint. Ein Speicher hilft zusätzlich dabei, auch außerhalb der Sonnenstunden mit selbst erzeugtem Strom zu laden.',
    },
    {
      q: 'Ich habe schon eine Wallbox, brauche nur den Elektro-Anschluss - geht das auch?',
      a: 'Ja - das deckt der Auftragstyp Elektroinstallation ab, unabhängig von einer kompletten PV-Anlage.',
    },
  ],
  primaryCta: { label: 'Anfrage mit Wallbox erstellen', action: 'customer' },
  secondaryCta: { label: 'Nur Wallbox nachrüsten?', action: 'link', href: '/photovoltaik-elektroinstallation' },
  relatedLinks: [
    { label: 'Was kostet eine Solaranlage?', href: '/solaranlage-kosten' },
    { label: 'So funktioniert der Angebotsvergleich', href: '/pv-angebot-vergleichen' },
    { label: 'Nur Elektroinstallation benötigt?', href: '/photovoltaik-elektroinstallation' },
  ],
}
